import { useState } from 'react'

import SearchBar from 'components/SearchBar'
import Select from 'components/Select'
import AddPosAccount from 'views/PosAccounts/AddPosAccount'

import { POS_STAFF_OPTIONS, POS_ROLES } from 'resources/POS_STAFF_OPTIONS'
import { TEmployeeRolesQuery } from 'types/posAccounts'

type TProps = {
  query: string
  setQuery: React.Dispatch<React.SetStateAction<string>>
  handleChangeStatusSelect: (val: string) => void
  handleChangeRolesSelect: React.Dispatch<React.SetStateAction<TEmployeeRolesQuery>>
}

const PosAccountsFilters = ({
  query,
  setQuery,
  handleChangeStatusSelect,
  handleChangeRolesSelect,
}: TProps) => {
  const [isOpenModal, setIsOpenModal] = useState(false)

  const onClickNew = () => {
    setIsOpenModal(true)
  }

  const onClose = () => {
    setIsOpenModal(false)
  }

  return (
    <>
      <div className="items-filters">
        <Select<TEmployeeRolesQuery>
          handleChange={handleChangeRolesSelect}
          options={POS_ROLES}
          label="All Staff"
          nameClass="-shorter -filter"
        />
        <Select
          handleChange={handleChangeStatusSelect}
          options={POS_STAFF_OPTIONS}
          label="All Statuses"
          nameClass="-shorter -filter"
        />
        <SearchBar searchQuery={query} handleSearch={setQuery} />
        <button className="btn new-item" type="button" onClick={onClickNew}>
          <span className="new-item -cross"></span>
          <span className="new-item -cross"></span>
        </button>
      </div>
      {isOpenModal && <AddPosAccount onClose={onClose} />}
    </>
  )
}

export default PosAccountsFilters
